<template>
  <div class="recruitment-no-filter-candidate">
    <h3>{{ title }}</h3>
    <p>{{ subtitle }}</p>
    <QBtn no-caps color="primary" :label="$t('ETAB.PAGES.CANDIDATE.FILTERS.@FILTER_INIT')" @click="$emit('deleteFilters')" />
    <img :src="img" :alt="$t('ETAB.PAGES.CANDIDATE.FILTERS.@NO_FILTERED_CANDIDATE_ALT')" />
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: "",
      },
      subtitle: {
        type: String,
        default: "",
      },
      img: {
        type: String,
        default: "",
      },
    },
    emits: ["deleteFilters"],
  };
</script>

<style lang="scss">
  .recruitment-no-filter-candidate {
    text-align: center;

    > img {
      width: 100%;
      max-width: 400px;
      margin: 15px 0;
    }

    h3,
    p {
      padding: 0 35px;
      text-align: center;
      line-height: 30px;
      color: $primary-lighter;
    }
  }
</style>
